<template>

    <div class="slide-in-page product-selector ">

        <!-- Title -->
        <div class="mt-4 product-selector__heading">
            <h1 class="d-inline">{{ $t('configurator.configurator') }}</h1>
            <router-link v-if="isLoggedIn" :to="{ name: 'Overview' }" class="medium-button blue-gradient quotation-button">{{ $t('quotation.quotationOverview')}} ({{$store.state.quoteCart.length}})</router-link>
        </div>

        <!-- Porduct selector -->
        <div class="product-selector__box bg-white rounded-10 shadow mb-5">

            <!-- Box title-->
            <div class="border-bottom mt-4 product-selector__box-title">
                <h2 class="">{{ $t('productSelector.selectProduct') }}</h2>
            </div>



            <!-- Categories -->
            <div class="product-selector__content">
                <div class="product-selector__categories side-shadow" id="">

                    <div v-on:click="UpdateChosenCategory(1);" class=" border rounded text-center product-selector__category" :class="{activeCategory: this.$route.params.category == 1}">
                        <img src="../../../src/assets/product-previews/preview-front-protection.png" />
                        {{ $t('productSelector.frontProtection') }}
                    </div>
                    <div v-on:click="UpdateChosenCategory(2);" class=" border rounded text-center product-selector__category" :class="{activeCategory: this.$route.params.category == 2}">
                        <img src="../../../src/assets/product-previews/preview-all-round-protection.png" />
                        {{ $t('productSelector.allRoundProtection') }}
                    </div>
                    <div v-on:click="UpdateChosenCategory(3);" class=" border rounded text-center product-selector__category" :class="{activeCategory: this.$route.params.category == 3}">
                        <img src="../../../src/assets/product-previews/preview-thyroid-collars.png" />
                        {{ $t('productSelector.thyroidCollars') }}
                    </div>
                    <div v-on:click="UpdateChosenCategory(4);" class=" border rounded text-center product-selector__category" :class="{activeCategory: this.$route.params.category == 4}">

                        <div class="svg-wrapper">
                            <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                            <path class="icon" d="M451.6,269.2L276.5,450c-11.3,11.7-29.7,11.7-41,0L60.3,269.2C9.4,216.6,12.4,129.5,69.3,81c49.6-42.3,123.5-34.7,168.9,12.3l17.8,18.4l17.8-18.4c45.5-47,119.3-54.6,168.9-12.3C499.6,129.5,502.6,216.6,451.6,269.2z" />
                            </svg>
                        </div>
                        Favorites
                    </div>

                </div>

                <!-- Models -->
                <!--<div class="product-selector__models ">-->
                <div v-if="$store.state.chosenCategory != 0" class="product-selector__subcategory" id="configurator" ref="configurator">
                    <router-link v-for="(prod, index) in cptProducts" :to="{ name: isLoggedIn ? 'Quotation' : 'Quotation_p', params: { sku: String(prod.apronModelID), favouriteid: 0} }" tag="div" :key="index" class="border rounded text-center item" :class="{disabled: prod.configurable == false}">

                        <!-- Best choice -->
                        <div v-if="prod.apronModelID == 66" class="best-choice shadow">
                            <span v-html="$t('productSelector.popularChoice')"></span>
                        </div>

                        <img :src="prod.previewImage" class="w-100" />

                        <!-- Combinations of 2 items that form 1 outfit (skirt & vest wraps) are called a set. If the product is part of a set, display the setName -->
                        <h3 v-if="prod.setWith != -1" class="font-weight-light">{{prod.setName}}</h3>
                        <h3 v-else class="font-weight-light">{{prod.name}}</h3>

                        <!-- SKU sends the selected model to the configurator -->
                        <router-link :to="{ name: isLoggedIn ? 'Quotation' : 'Quotation_p', params: { favouriteid: 0, sku: String(prod.apronModelID)} }" class="medium-button blue-gradient mt-5" :class="{disabled: prod.configurable == false}"> {{ $t('configurator.configure') }}</router-link>
                    </router-link>

                    <div v-if="$store.state.chosenCategory == 4" class="favorite-configurations ">

                        <!-- Search bar-->
                        <div class="favorite-configurations__searchbar">
                            <!-- Sort controls -->

                            <ul class="favorite-configurations__sort">
                                <li @click="sortFavorites('name')">{{ $t('general.name')}}  <sorting-icon :current-sort-property="sortBy" sortProperty="name" :reverse="reverse"></sorting-icon></li>
                                <li @click="sortFavorites('configuredApron.model.name')">{{ $t('addEditApron.model')}} <sorting-icon :current-sort-property="sortBy" sortProperty="configuredApron.model.name" :reverse="reverse"></sorting-icon></li>
                                <li @click="sortFavorites('favouriteApronID')">{{ $t('productSelector.added')}} <sorting-icon :current-sort-property="sortBy" sortProperty="favouriteApronID" :reverse="reverse"></sorting-icon></li>
                            </ul>
                            <search-box></search-box>
                        </div>

                        <!-- Favorites -->
                        <div v-if="favoritesLoading === false" class="favorite-configurations__favorites ">
                            <div v-for="favorite in sortedFilterdFavorites" :key="favorite.id" class="favorite-configurations__item border rounded">
                                <div class="favorite-configurations__preview">

                                    <apron-preview :configured-apron="favorite.configuredApron" :configured-skirt="favorite.configuredSkirt" style="height: 240px" class="item-preview"></apron-preview>

                                    <!--<img src="../../assets/product-previews/preview-all-round-protection.png" />-->
                                </div>
                                <div class="favorite-configurations__content">
                                    <h3 class="font-weight-light">{{favorite.name}}</h3>
                                    <div class="favorite-configurations__small-buttons mt-2">
                                        <a v-on:click="confirmDeleteFavorite(favorite)" class="small-button color-magenta mr-4"><b-icon-trash-fill />  {{ $t('general.delete') }}</a>
                                        <a v-on:click="updateFavoriteName(favorite.favouriteApronID)" class="small-button color-magenta"><b-icon-pencil-fill />  {{ $t('general.rename') }}</a>
                                    </div>

                                    <!-- IS ONLY APRON -->
                                    <table v-if="!favorite.configuredApron.model.setModel" class="w-100 mt-4">
                                        <tr>
                                            <td colspan="2" class="detail">
                                                {{favorite.configuredApron.model.name}}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td class="detail">{{ $t('addEditApron.size') }}</td>
                                            <td> {{SizeToString(favorite.configuredApron.size)}}<span v-if="favorite.configuredSkirt"> / {{favorite.configuredSkirt.fabricColor.name}}</span></td>
                                        </tr>
                                        <tr>
                                            <td class="detail">{{ $t('productSelector.colorScheme') }}</td>
                                            <td>{{favorite.configuredApron.fabricColor.name}} / {{favorite.configuredApron.ribbonColor.name}}</td>
                                        </tr>
                                    </table>

                                    <!-- IS VEST/SKIRT COMBI -->
                                    <table v-else class="w-100 mt-4">
                                        <tr>
                                            <td colspan="2" class="detail">
                                                {{favorite.configuredApron.model.name}}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td class="detail">{{ $t('addEditApron.size') }}</td>
                                            <td>
                                                <span v-if="favorite.sku">{{$t('quotation.vest')}}:    {{SizeToString(favorite.configuredApron.size)}} </span>
                                                <span v-if="favorite.skuSkirt"> {{$t('quotation.skirt')}}:  {{SizeToString(favorite.configuredSkirt.size)}}</span>
                                            </td>
                                        </tr>
                                        <tr v-if="favorite.sku">
                                            <td v-if="favorite.configuredApron.includeInQuote" class="detail">{{ $t('productSelector.colorScheme') }} {{$t('quotation.vest')}}</td>
                                            <td v-if="favorite.configuredApron.includeInQuote" >{{favorite.configuredApron.fabricColor.name}} / {{favorite.configuredApron.ribbonColor.name}}</td>
                                        </tr>
                                        <tr v-if="favorite.skuSkirt">
                                            <td  v-if="favorite.configuredSkirt.includeInQuote" class="detail">{{ $t('productSelector.colorScheme') }} {{$t('quotation.skirt')}}</td>
                                            <td  v-if="favorite.configuredSkirt.includeInQuote">{{favorite.configuredSkirt.fabricColor.name}} / {{favorite.configuredSkirt.ribbonColor.name}}</td>
                                        </tr>
                                    </table>
                                    <div class="favorite-configurations__medium-buttons mt-4">
                                        <router-link :to="{ name: isLoggedIn ? 'Quotation' : 'Quotation_p', params: { sku: favorite.sku , sku2: favorite.skuSkirt, favouriteid: favorite.favouriteApronID}}" class="medium-button blue-gradient mr-3">{{ $t('productSelector.open')}}</router-link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!--</div>-->

</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex';
    import SearchBox from '@/private/components/Tables/SearchBox.vue';
    import ApronPreview from '@/private/components/Configurator/ApronPreview.vue';
    import SaveFavorite from "@/private/components/ModalContent/SaveFavorite.vue";
    import SimpleAcceptDecline from "@/private/components/ModalContent/SimpleAcceptDecline.vue";
    import { skuToConfig, SizeToString } from '@/scripts/General.js';
    import Bus from '@/Bus.js';
    import _ from 'lodash';
    import SortingIcon from '@/private/components/Tables/SortingIcon.vue';

    export default {
        name: 'ProductSelector',

        props: {

        },
        components: {
            SearchBox,
            ApronPreview,
            SortingIcon
        },
        data: function () {

            return {
                storeLoading: true,
                favoritesLoading: true,
                lstModels: [],
                lstFavorites: [],
                sortBy: 'name',
                sortDirection: 'asc',
                reverse: false,

            }

        },
        beforeMount: function () {


        },
        mounted: function () {

            this.$store.dispatch('GET_quoteCart');

            if (this.$route.params.category != null) {
                //Set category if known from URL
                this.UpdateChosenCategory(this.$route.params.category)
            } else {
                this.UpdateChosenCategory(1)
            }

        },
        methods: {
            GoToItem: function () {
                this.$routr.push();
            },

            GetStoreModel: function () {

                this.storeLoading = true;

                const getModels = async () => {
                    try {
                        const resp = await axios.get('/Store/GetStoreModel');

                        //List of all models
                        this.lstModels = resp.data.lstModels;

                        //Quote shopping basket
                        this.lstQuoteBasket = resp.data.lstQuoteBasket;

                        return resp.data;
                    } catch (error) {
                        alert(error)
                    }
                }
                this.storeLoading = false;
                return getModels();
            },

            GetFavorites: function () {

                this.favoritesLoading = true;

                const getFavo = async () => {
                    try {
                        const resp = await axios.get('/Dashboard/GetOurFavourites');

                        this.lstFavorites = resp.data;
                        return resp.data;

                    } catch (err) { alert(err) }
                }

                return getFavo();

            },
            updateFavoriteName: function (id) {

                const itemToUpdate = this.lstFavorites.find(x => x.favouriteApronID === id);

                //const currentData = itemToUpdate;
                const currentData = {
                    name: itemToUpdate.name,
                    favouriteApronID: itemToUpdate.favouriteApronID,
                    sku: itemToUpdate.sku,
                    skuSkirt: itemToUpdate.skuSkirt
                };

                Bus.$emit('set-modal-data', currentData, SaveFavorite, this.$t('productSelector.renameFavoriteTitle'));
                Bus.$emit('open-modal');

                Bus.$on('close-modal', (newName) => { itemToUpdate.name = newName });

            },
            confirmDeleteFavorite: function (favorite) {
                const objProps = {
                    message: this.$t('productSelector.areYouSureDeleteFavorite', [favorite.name])
                }

                Bus.$emit('set-modal-data', objProps, SimpleAcceptDecline, this.$t('general.attention'))
                Bus.$emit('open-modal')

                //Event handlers
                Bus.$on('yes-pressed', () => { this.DeleteFavorite(favorite) })
                Bus.$on('no-pressed', () => { Bus.$emit('close-modal') })
            },
            DeleteFavorite: function (favorite) {

                axios.post('/Dashboard/RemoveFavourite', favorite.favouriteApronID, {
                    headers: { 'content-type': 'application/json' }
                })
                    .then((response) => {
                        if (response.status == 200) {

                            if (response.data != "OK") {
                                //An error came from the server
                                this.serverResponse = response.data
                            } else {
                                //remove from array
                                const idx = this.lstFavorites.map(x => x.favouriteApronID).indexOf(favorite.favouriteApronID);
                                this.lstFavorites.splice(idx, 1);
                            }


                            //Close the confirmation modal
                            Bus.$emit('close-modal');
                        }
                    })
                    .catch(function (error) {
                        alert(error);
                    }
                    );
            },
            isSelectedCategory: function (categoryID) {
                if (categoryID == this.$store.state.chosenCategory) {
                    return 'bold'
                } else {
                    return ''
                }
            },
            UpdateChosenCategory: function (newValue) {
                this.$store.commit('SET_chosenCategory', newValue)

                if (newValue == 4) {
                    this.addProppertiesToFavorite();

                }

                //Update URL slug
                this.$router.replace({ name: this.$route.name, params: { category: this.$store.state.chosenCategory } }).catch(() => { })

            },
            addProppertiesToFavorite: async function () {
                const resultFavorites = await this.GetFavorites();
                const resultModels = await this.GetStoreModel();

                //check if all data is avaible
                if (resultFavorites && resultModels) {

                    for (const favorite of this.lstFavorites) {

                        //Add configured propperties to skirt
                        favorite.configuredApron = skuToConfig(favorite.sku, this.lstModels, 'simple');

                        //properties for preview
                        favorite.configuredApron.apronModelID = favorite.configuredApron.model.apronModelID;
                        favorite.configuredApron.fabricColorID = favorite.configuredApron.fabricColor.fabricColorID;
                        favorite.configuredApron.ribbonColorID = favorite.configuredApron.ribbonColor.ribbonColorID;
                        //check if model is part of set
                        if (favorite.skuSkirt) {
                            favorite.configuredSkirt = skuToConfig(favorite.skuSkirt, this.lstModels, 'simple')

                            //properties for preview
                            favorite.configuredSkirt.apronModelID = favorite.configuredSkirt.model.apronModelID;
                            favorite.configuredSkirt.fabricColorID = favorite.configuredSkirt.fabricColor.fabricColorID;
                            favorite.configuredSkirt.ribbonColorID = favorite.configuredSkirt.ribbonColor.ribbonColorID;
                        } else {
                            favorite.configuredSkirt = null;
                        }
                    }

                    //this.lstFavorites.forEach(favorite => favorite.configuredApron = this.skuToConfigSimple(favorite.sku));
                    this.favoritesLoading = false;
                }
            },

            SizeToString: SizeToString,

            sortFavorites: function (val) {
                if (val === this.sortBy) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                    this.reverse = !this.reverse;
                }
                this.sortBy = val
            }
        },
        computed: {
            cptProducts: function () {
                var categoryProducts = this.lstModels.filter(x => x.category == this.$store.state.chosenCategory);

                var returnValue = []

                //filter out combos
                for (var i = 0; i < categoryProducts.length; i++) {
                    if (returnValue.filter(x => x.apronModelID == categoryProducts[i].apronModelID).length == 0 && returnValue.filter(x => x.apronModelID == categoryProducts[i].setWith).length == 0) {
                        //Add
                        returnValue.push(categoryProducts[i])
                    }
                }

                return returnValue
            },
            ...mapState({
                isLoggedIn: state => state.isLoggedIn
            }),
            filterdFavorites: function () {

                return this.lstFavorites.filter(favorite => {
                    const names = favorite.name.toLowerCase();
                    const fabricColorsApron = favorite.configuredApron.fabricColor.name.toLowerCase();
                    const ribbonColorsApron = favorite.configuredApron.ribbonColor.name.toLowerCase();
                    const models = favorite.configuredApron.model.name.toLowerCase();

                    let tmpFabric
                    let tmpRibbon

                    if (favorite.configuredSkirt !== null) {
                        if (favorite.configuredSkirt.fabricColorID !== undefined) {
                            tmpFabric = favorite.configuredSkirt.fabricColor.name.toLowerCase();
                            tmpRibbon = favorite.configuredSkirt.ribbonColor.name.toLowerCase();
                        } else {
                            tmpFabric = ''
                            tmpRibbon = ''
                        }
                    } else {
                        tmpFabric = ''
                        tmpRibbon = ''
                    }
                    const fabricColorsSkirt = tmpFabric;
                    const ribbonColorsSkirt = tmpRibbon;

                    const searchTerm = this.$store.state.searchTerm.toLowerCase();

                    return names.includes(searchTerm) ||
                        fabricColorsApron.includes(searchTerm) ||
                        ribbonColorsApron.includes(searchTerm) ||
                        ribbonColorsSkirt.includes(searchTerm) ||
                        fabricColorsSkirt.includes(searchTerm) ||
                        models.includes(searchTerm)
                }

                );
            },
            sortedFilterdFavorites: function () {
                return _.orderBy(this.filterdFavorites,
                    [favorite => {
                        if (this.sortBy === 'favouriteApronID') {
                            return _.get(favorite, this.sortBy);
                        } else {
                            return _.get(favorite, this.sortBy).toLowerCase();
                        }
                    }],
                    this.sortDirection);
            }
        },
        watch: {

        },
        created() {
            this.GetStoreModel();

        },
        updated() {
           
        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
